module.exports = __webpack_public_path__ + "static/edit-banner-topbar-custom-links-a47ad73a18f5be93ae5dccf169fb5428.png";